import React, { useEffect } from 'react';
import queryString from 'query-string';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ translate, location }) => {
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  useEffect(() => {
    document.body.className = 'cableatierra-oauth-body';
    document.title = 'Cable a Tierra';
  }, []);

  return (
    <div className="cableatierra-oauth">
      {
        _validateParams()
          ? <LoginForm
          api={api}
          location={location} />
          :<RequestLoginErrorMessage
          onlyMessage={true}
          message={translate('RequestLoginErrorMessage')} />}
    </div>
  );
}

export default Login;
